import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Table,
} from "reactstrap";
import { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Header from "components/Headers/Header";

const ConsultarGlpi = () => {
  const [numeroCaso, setNumeroCaso] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const handleConsultar = async () => {
    if (!numeroCaso) {
      setError("Por favor ingrese un número de caso.");
      return;
    }

    setError(null); // Limpia errores previos
    try {
      const response = await axios.get(
        `https://apioraclecpqicontec.azurewebsites.net/api/ObtenerAdjunto/${numeroCaso}`
      );
      setData(response.data);
      console.log(data);
    } catch (err) {
      setError(
        "No se pudo obtener información del caso. Verifique el número e intente nuevamente."
      );
      setData(null);
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col className="text-right" xs="4"></Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">Consultas</h6>
                  <div className="pl-lg-4">
                    <FormGroup>
                      <Input
                        className="form-control-alternative"
                        id="input-numero-caso"
                        placeholder="Número de Caso"
                        type="text"
                        value={numeroCaso}
                        onChange={(e) => setNumeroCaso(e.target.value)}
                      />
                    </FormGroup>
                    <button
                      type="button"
                      className="btn btn-primary btn-lg"
                      onClick={handleConsultar}
                    >
                      Consultar
                    </button>
                  </div>
                  {error && <div className="text-danger mt-3">{error}</div>}
                  {data && data.length > 0 && (
                    <Table
                      className="align-items-center table-flush mt-4"
                      responsive
                    >
                      <thead className="thead-light">
                        <tr>
                          <th>ID Ticket</th>
                          <th>Fecha Creación</th>
                          <th>Nombre</th>
                          <th>Archivo</th>
                          <th>Descargar</th>
                        </tr>
                      </thead>

                      <tbody>
                        {data.map((item) => (
                          <tr key={item.id}>
                            <td>{item.tickets_id}</td>
                            <td>{item.date_creation}</td>
                            <td>{item.name}</td>
                            <td>{item.filename}</td>
                            <td>
                              <a
                                href={item.descarga}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-success btn-sm"
                              >
                                Descargar
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                  {data && data.length === 0 && (
                    <div className="text-muted mt-3">
                      No se encontraron resultados para el caso ingresado.
                    </div>
                  )}
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ConsultarGlpi;
